module.exports = __webpack_public_path__ + "img/works_orangelife_btm.6eaa394b.jpg";